import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCpscCertificateFields = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableCpscCertificateFields);
};
